var _ = require('underscore');
var moment = require('moment-strftime');

module.exports = function (env) {
    var staticPath = '/static/';

    if (typeof window !== 'undefined') {
        staticPath = window.app.settings.staticUrl;
    }

    env.addGlobal('getLoggedId', function () {
        return window.app.settings.member;
    });

    env.addGlobal('static', function (file) {
        return staticPath + file;
    }, true);

    env.addGlobal('url', function (name, params) {
        params = params || {};

        return Urls[name].apply(null, params.args);
    }, true);

    env.addGlobal('domain_url', function (site, name, params) {
        params = params || {};
        if (site == 2) {
            return '//' + app.settings.sites['' + site] + UrlsAvailability['availability:' + name].apply(null, params.args);
        }
    });

    env.addFilter('tojson', function (obj) {
        return JSON.stringify(obj);
    });

    env.addFilter('datetime', function (date, format) {
        return moment.parseZone(date).strftime(format);
    });

    env.addFilter('datetimeNoZeroPadding', function (date, format) {
        return moment.parseZone(date).strftime(format).replace(/(\D|^)0([0-9])/g, '$1$2');
    });

    env.addFilter('tail', function (value, start) {
        return value.slice(start);
    });

    env.addGlobal('dateRange', function (date, dateEnd, format) {
        var dt = moment.parseZone(date, moment.ISO_8601);
        var dtEnd = dateEnd && moment.parseZone(dateEnd, moment.ISO_8601) || undefined;

        if (dtEnd && !dt.clone().startOf('day').
            isSame(dtEnd.clone().startOf('day'))) {
            return dt.strftime(format) + ' – ' + dtEnd.strftime(format);
        }

        return moment.parseZone(date).strftime(format);
    });

    env.addGlobal('debug', function (data) {
        console.log('nunjucks debug:', data);
    });

    env.addGlobal('debugjson', function (data) {
        console.log('nunjucks debug:', JSON.stringify(data));
    });

    env.addGlobal('timeRange', function (date, dateEnd, time, timeEnd, format) {
        var dt = moment.parseZone(date, moment.ISO_8601);
        var dtEnd = dateEnd && moment.parseZone(dateEnd, moment.ISO_8601) || undefined;

        if (timeEnd) {
            return dt.strftime(format) + ' – ' + dtEnd.strftime(format);
        }

        if (time) {
            return dt.strftime(format);
        }

        return '';
    });

    env.addFilter('add_social', function (str, tp) {
        return str;
    });

    env.addFilter('is_none', function (obj) {
        return !!obj;
    });

    env.addGlobal('get_current_url', function() {
      return window.location.href;
    });

    env.addFilter('json_escape', function (value) {
        return JSON.stringify(String(value)).slice(1, -1);  // stringify, then strip outer quotes
    });
};





//////////////////
// WEBPACK FOOTER
// ./nunjucks.config.js
// module id = 3
// module chunks = 0